/* Fabrica Kraft – saved designs, "design is ready" card, room completion nudge, trade tier pricing (v76, Oct 2026) */
(function () {
  'use strict';
  var KEY = 'fkDesigns', MAX = 24, ROOM_CODE = 'COMPLETEROOM10', PAGE = '/pages/my-designs';
  var cfg = window.FKD || {};
  var trade = cfg.trade && cfg.trade.code ? cfg.trade : null;

  /* ---------- helpers ---------- */
  function load() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function store(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); return true; } catch (e) { return false; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function enc(o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function dec(s) { try { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return JSON.parse(decodeURIComponent(escape(atob(s)))); } catch (e) { return null; } }
  function toast(msg) {
    var t = document.querySelector('.fkd-toast') || document.body.appendChild(el('div', 'fkd-toast'));
    t.setAttribute('role', 'status'); t.innerHTML = msg; t.classList.add('is-on');
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }
  function applyCode(code) {
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
  }
  var HEART = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
  var SHARE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 15V4M8 8l4-4 4 4M5 13v6h14v-6"/></svg>';

  /* ---------- trade pricing: apply the tier code once per session ---------- */
  if (trade && ss('fkdTrade') !== trade.code) {
    applyCode(trade.code).then(function () { ss('fkdTrade', trade.code); });
  }

  /* ---------- header: saved designs link (only once something is saved) ---------- */
  function header() {
    var n = load().length, a = document.querySelector('.fkd-hdr');
    if (!n) { if (a) a.remove(); return; }
    if (!a) {
      var cart = document.querySelector('.fkh a.fkh__icon[href$="/cart"]');
      if (!cart) return;
      a = el('a', 'fkh__icon fkd-hdr', HEART + '<span class="fkh__count"></span>');
      a.href = PAGE; cart.parentNode.insertBefore(a, cart);
    }
    a.setAttribute('aria-label', 'My designs, ' + n + ' saved');
    a.querySelector('.fkh__count').textContent = n;
  }

  /* ---------- design records ---------- */
  function shareUrl(d) { return location.origin + d.url + (d.url.indexOf('?') < 0 ? '?' : '&') + 'fkd=' + d.s; }
  function share(d, btn) {
    var url = shareUrl(d), title = d.spec;
    if (navigator.share) { navigator.share({ title: title, text: title + ' – designed on Fabrica Kraft', url: url }).catch(function () {}); return; }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      if (btn) { var o = btn.innerHTML; btn.innerHTML = 'Link copied'; setTimeout(function () { btn.innerHTML = o; }, 1800); }
    }).catch(function () { window.prompt('Copy this link', url); });
  }

  /* ---------- email capture (optional, after first save) ----------
     Submits the real Shopify customer form rendered in Liquid (#fkd-signup in custom-code-body), so Shopify's spam check passes.
     The customer is subscribed and tagged "saved-design"; a Shopify Flow then sends the "Your designs are saved" email. */
  function emailForm(where) {
    var sf = document.getElementById('fkd-signup');
    if (!sf || cfg.email || ss('fkdAsked') === '1' || localStorage.getItem('fkdEmail')) return;
    sf.style.display = ''; where.appendChild(sf);
    if (sf.fkdWired) return; sf.fkdWired = true;
    sf.querySelector('.fkd-x').onclick = function () { ss('fkdAsked', '1'); sf.style.display = 'none'; };
    /* let the browser submit the real form; just remember the email and come back to the same design */
    sf.addEventListener('submit', function () {
      var em = (sf.querySelector('[name="contact[email]"]').value || '').trim();
      try { localStorage.setItem('fkdEmailPending', em); } catch (x) {}
      if (root && S()) { try { var u = shareUrl(current()); history.replaceState(null, '', u.replace(location.origin, '')); } catch (x) {} }
    });
  }
  function signupDone() {
    var pend; try { pend = localStorage.getItem('fkdEmailPending'); } catch (x) {}
    if (!pend || !/[?&]customer_posted=true/.test(location.search)) return;
    try { localStorage.removeItem('fkdEmailPending'); localStorage.setItem('fkdEmail', pend); } catch (x) {}
    history.replaceState(null, '', location.pathname + location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?') + location.hash.replace(/#fkd-signup$/, ''));
    setTimeout(function () { toast('<b>You\'re in.</b> Check your inbox at ' + esc(pend) + '. Your designs are in <a href="' + PAGE + '">My designs</a>.'); }, 800);
  }

  /* ---------- builder integration ---------- */
  var root = document.querySelector('.fks');
  function S() { return window.FKS; }
  function q(k) { return root && root.querySelector('[data-fks="' + k + '"]'); }

  function spec() {
    var parts = ((q('sentence') || {}).textContent || '').split(' Plus ')[0].replace(/\.$/, '').split(', '), out = [parts.shift() || ''];
    /* keep going until the size and the fabric are both in (curtains read "1 panel, each 50 wide × 96 long, in …") */
    while (parts.length && (out.join(', ').indexOf('×') < 0 || !/ in |^in /.test(out.join(', ')))) out.push(parts.shift());
    var s = out.join(', ').trim();
    return s ? 'Your ' + s : 'Your design';
  }
  function snapshot(w) {
    var src = root.querySelector('[data-fks="room"]:not([hidden]) canvas') || root.querySelector('.fkb__media canvas:not([hidden])');
    var c = document.createElement('canvas'), h = Math.round(w * 0.72);
    c.width = w; c.height = h;
    try {
      if (src && src.width > 50) {
        var r = Math.max(w / src.width, h / src.height), sw = w / r, sh = h / r;
        c.getContext('2d').drawImage(src, (src.width - sw) / 2, (src.height - sh) / 2, sw, sh, 0, 0, w, h);
        return c;
      }
    } catch (e) {}
    return null;
  }
  function thumbData() {
    var c = snapshot(320); if (!c) return '';
    try { return c.toDataURL('image/jpeg', 0.72); } catch (e) { return ''; }
  }
  function stateNow() {
    var F = S().F, o = {};
    Object.keys(F).forEach(function (k) { if (k !== 'swAdded') o[k] = F[k]; });
    return o;
  }
  function complete() {
    var api = S(), atc = q('atc');
    if (!api || !api.fab() || !atc || atc.disabled) return false;
    return /add to cart/i.test(atc.textContent || '');
  }
  function current() {
    var api = S(), fab = api.fab(), st = stateNow();
    return {
      id: Date.now().toString(36), at: Date.now(), url: location.pathname,
      spec: spec(), price: ((q('price') || {}).textContent || '').trim(),
      title: ((q('title') || {}).textContent || document.title).trim(),
      img: thumbData(), fab: api.img(fab, 200), s: enc(st), key: enc([st.type, st.fab, st.shape, st.w, st.d, st.t, st.rw, st.np, st.style, st.use, st.foam, st.welt, st.ties, st.qty])
    };
  }
  function isSaved(k) { return load().some(function (d) { return d.key === k; }); }

  var card, emailHost, nudgeShown = false;
  function hasPil() { var f = q('fbt'); return !!(f && !f.hidden && /pillow/i.test(f.textContent || '')); }
  function renderCard() {
    if (!root || !S()) return;
    var summary = root.querySelector('.fkb__summary');
    if (!summary) return;
    if (!card) { card = el('div', 'fkd-ready'); card.hidden = true; summary.parentNode.insertBefore(card, summary); }
    if (!complete()) { card.hidden = true; return; }
    var api = S(), F = api.F, kind = api.kind(), d = current(), saved = isSaved(d.key);
    var canNudge = !trade && kind === 'cushion' && F.type !== 'pillow' && !F.addPil && hasPil();
    card.hidden = false;
    card.innerHTML =
      '<div class="fkd-ready__media"><canvas aria-hidden="true"></canvas>' + (d.fab ? '<img alt="" src="' + esc(d.fab) + '">' : '') + '</div>' +
      '<div class="fkd-ready__body"><span class="fkd-eyebrow">Your design is ready</span>' +
      '<p class="fkd-ready__spec">' + esc(d.spec) + '</p>' +
      '<div class="fkd-ready__btns"><button type="button" class="fkd-btn' + (saved ? ' is-on' : '') + '" data-fkd="save" aria-pressed="' + saved + '">' + HEART + '<span>' + (saved ? 'Saved' : 'Save design') + '</span></button>' +
      '<button type="button" class="fkd-btn" data-fkd="share">' + SHARE + '<span>Share</span></button>' +
      (saved ? '<a class="fkd-link" href="' + PAGE + '">My designs</a>' : '') + '</div></div>' +
      (canNudge ? '<button type="button" class="fkd-nudge" data-fkd="pil"><b>Complete the look:</b> add matching throw pillows · 10% off your order</button>' : '');
    var big = snapshot(360), cv = card.querySelector('canvas');
    if (big) { cv.width = big.width; cv.height = big.height; cv.getContext('2d').drawImage(big, 0, 0); card.classList.add('has-room'); }
    else card.classList.remove('has-room');
    card.querySelector('[data-fkd="save"]').onclick = function () {
      var list = load(), k = d.key, was = isSaved(k);
      if (was) store(list.filter(function (x) { return x.key !== k; }));
      else { var rec = current(); list.unshift(rec); if (!store(list)) { rec.img = ''; store(list); } }
      header(); renderCard();
      if (!was) {
        toast('Saved to <a href="' + PAGE + '">My designs</a>');
        if (!emailHost) { emailHost = el('div', 'fkd-email-host'); card.parentNode.insertBefore(emailHost, card.nextSibling); }
        emailForm(emailHost);
      }
    };
    card.querySelector('[data-fkd="share"]').onclick = function () { share(current(), this.querySelector('span')); };
    var p = card.querySelector('[data-fkd="pil"]');
    if (p) p.onclick = function () { ss('fkdRoom', '1'); api.set({ addPil: true }); var f = q('fbt'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
  }

  function afterAdd() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var pieces = (c.items || []).filter(function (i) { return i.properties && i.properties._fk_studio; });
      if (trade) return;
      if (pieces.length >= 2) {
        applyCode(ROOM_CODE).then(function () { toast('<b>Room complete.</b> 10% off is applied at checkout.'); });
        var n = root.querySelector('.fkd-after'); if (n) n.remove();
        return;
      }
      var api = S(); if (!api || nudgeShown || api.kind() !== 'cushion' || api.F.type === 'pillow' || api.F.addPil) return;
      nudgeShown = true;
      var fab = api.fab(), name = fab ? api.name(fab) : 'the same fabric';
      var box = el('div', 'fkd-after', '<p><b>Added to your cart.</b> Complete the room with matching throw pillows in ' + esc(name) + ' and get 10% off your order.</p>' +
        '<button type="button" class="fkd-btn fkd-btn--dark">Design matching pillows</button>');
      var sum = root.querySelector('.fkb__summary'); sum.appendChild(box);
      box.querySelector('button').onclick = function () {
        ss('fkdRoom', '1'); box.remove(); api.type('pillow');
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
    }).catch(function () {});
  }

  function restore() {
    var m = location.search.match(/[?&]fkd=([^&]+)/); if (!m) return;
    var st = dec(m[1]); if (!st) return;
    /* the builder resets sizes while its fabric list loads, so apply the saved state until it sticks */
    var tries = 0, ok = 0;
    (function wait() {
      var api = S();
      if (api) {
        var F = api.F, same = F.type === st.type && F.w === st.w && F.d === st.d && F.t === st.t && F.fab === st.fab;
        if (!same) { api.set(st); ok = 0; } else if (api.fab()) ok++;
        if (ok >= 4) return;
      }
      if (++tries < 60) setTimeout(wait, 250);
    })();
  }

  function initBuilder() {
    if (!root) return;
    var tries = 0;
    (function wait() {
      if (!S()) { if (++tries < 80) setTimeout(wait, 150); return; }
      restore();
      var t, obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(renderCard, 120); });
      [q('sentence'), q('atc'), q('price'), q('room')].forEach(function (n) { if (n) obs.observe(n, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'class'] }); });
      document.addEventListener('fks:added', afterAdd);
      renderCard();
    })();
  }

  /* ---------- My Designs page ---------- */
  function initPage() {
    var host = document.querySelector('[data-fkd-page]'); if (!host) return;
    function draw() {
      var list = load();
      if (!list.length) {
        host.innerHTML = '<div class="fkd-empty"><p>You have no saved designs yet.</p><p class="fkd-muted">Build a cushion, pillow or curtain and tap <b>Save design</b> when it is ready. Your designs stay on this device.</p><a class="fkd-btn fkd-btn--dark" href="/">Start designing</a></div>';
        return;
      }
      host.innerHTML = '<p class="fkd-muted">' + list.length + ' saved design' + (list.length > 1 ? 's' : '') + ' on this device. Prices shown are from when you saved; opening a design shows today\'s price.</p><div class="fkd-grid"></div>';
      var g = host.querySelector('.fkd-grid');
      list.forEach(function (d) {
        var c = el('article', 'fkd-card');
        var img = d.img || d.fab;
        c.innerHTML = '<a class="fkd-card__img" href="' + esc(shareUrl(d)) + '">' + (img ? '<img alt="" loading="lazy" src="' + esc(img) + '">' : '') + '</a>' +
          '<div class="fkd-card__body"><p class="fkd-card__spec">' + esc(d.spec) + '</p>' +
          '<p class="fkd-muted">' + esc(d.price) + ' · saved ' + new Date(d.at).toLocaleDateString() + '</p>' +
          '<div class="fkd-ready__btns"><a class="fkd-btn fkd-btn--dark" href="' + esc(shareUrl(d)) + '">Open</a>' +
          '<button type="button" class="fkd-btn" data-a="share">' + SHARE + '<span>Share</span></button>' +
          '<button type="button" class="fkd-link" data-a="rm">Remove</button></div></div>';
        c.querySelector('[data-a="share"]').onclick = function () { share(d, this.querySelector('span')); };
        c.querySelector('[data-a="rm"]').onclick = function () { store(load().filter(function (x) { return x.id !== d.id; })); header(); draw(); };
        g.appendChild(c);
      });
      emailForm(host);
    }
    draw();
  }

  function init() { header(); initBuilder(); initPage(); signupDone(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('storage', function (e) { if (e.key === KEY) header(); });
})();
